import {Storage} from "platform/storage/Storage";

export class WebStorage implements Storage {

    private static _instance: Storage;

    private constructor() {
    }

    public static instance(): Storage {
        return this._instance || (this._instance = new this());
    }

    public setItem(key: string, data: string): void {
        window.localStorage.setItem(key, data);
    }

    public getItem(key: string): Promise<string | any> {
        return Promise.resolve(window.localStorage.getItem(key));
    }

    public removeItem(key: string): void {
        window.localStorage.removeItem(key);
    }
}
